export default "__VITE_ASSET__DL0LJ0la__"